import { StringUtils } from '@uploadcam/common';

export interface AuthSecurityTokens {
  pkceChallenge: string;
  pkceVerifier: string;
  state: string;
}

export class GenerateAuthSecurityTokensInteractor {
  public async execute(): Promise<AuthSecurityTokens> {
    const pkceVerifier = this.generateRandomString();
    const hash = crypto.subtle.digest('SHA-256', new TextEncoder().encode(pkceVerifier));
    const pkceChallenge = await hash.then(this.bufferToBase64Url);
    // TODO: This uses `Math.random()` which is not cryptographically secure. Consider using `window.crypto.getRandomValues()` for better security.
    const state = StringUtils.randomString(10);

    return { pkceVerifier, pkceChallenge, state };
  }

  private generateRandomString(): string {
    var array = new Uint32Array(28);
    window.crypto.getRandomValues(array);
    return Array.from(array, (dec) => ('0' + dec.toString(16)).slice(-2)).join('');
  }

  private bufferToBase64Url(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let base64 = btoa(String.fromCharCode(...bytes));
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
}
